import {
  account_path,
  account_users_path,
  activate_profile_index_path,
  add_to_favorites_job_path,
  admin_campaign_path,
  admin_campaigns_path,
  admin_companies_path,
  admin_country_page_path,
  admin_country_pages_path,
  admin_dashboard_index_path,
  admin_development_data_path,
  admin_development_data_automation_dashboard_path,
  admin_development_data_contract_path,
  admin_development_data_contracts_path,
  admin_development_data_donors_path,
  admin_development_data_grant_path,
  admin_development_data_grants_path,
  admin_development_data_open_opportunities_path,
  admin_development_data_open_opportunity_path,
  admin_development_data_organization_path,
  admin_development_data_organization_company_link_path,
  admin_development_data_organization_company_links_path,
  admin_development_data_organizations_path,
  admin_development_data_pipeline_path,
  admin_development_data_pipelines_path,
  admin_development_data_raw_funding_info_path,
  admin_development_data_raw_funding_infos_path,
  admin_development_data_scrape_run_path,
  admin_development_data_scrape_runs_path,
  admin_development_data_search_path,
  admin_development_data_tender_path,
  admin_development_data_tenders_path,
  admin_funding_path,
  admin_job_path,
  admin_jobs_path,
  admin_landing_page_path,
  admin_landing_pages_path,
  admin_news_lab_article_path,
  admin_news_lab_article_assign_google_doc_path,
  admin_news_lab_articles_path,
  admin_news_lab_content_path,
  admin_news_lab_events_path,
  admin_news_lab_google_document_path,
  admin_news_lab_partners_path,
  admin_news_lab_root_path,
  admin_newsletter_path,
  admin_newsletters_path,
  admin_payment_page_path,
  admin_payment_page_item_path,
  admin_payment_page_items_path,
  admin_payment_pages_path,
  admin_permissions_path,
  admin_procurement_shortlist_path,
  admin_procurement_shortlists_path,
  admin_root_path,
  admin_story_type_path,
  admin_story_types_path,
  admin_user_path,
  admin_user_switch_path,
  admin_users_path,
  api_path,
  api_activities_path,
  api_analytics_job_applications_path,
  api_autocomplete_path,
  api_autocomplete_jobs_employer_companies_path,
  api_autocomplete_locations_path,
  api_autocomplete_places_path,
  api_autocomplete_projects_by_reference_number_path,
  api_bookmarked_search_path,
  api_consultant_request_cv_path,
  api_consultants_path,
  api_consultants_search_path,
  api_content_events_path,
  api_current_user_path,
  api_current_user_addresses_path,
  api_current_user_associations_path,
  api_current_user_credits_path,
  api_current_user_documents_path,
  api_current_user_education_path,
  api_current_user_employments_path,
  api_current_user_links_path,
  api_current_user_messengers_path,
  api_current_user_messengers_bulk_path,
  api_current_user_newsletters_path,
  api_current_user_notes_path,
  api_current_user_photos_path,
  api_current_user_profile_views_path,
  api_current_user_references_path,
  api_current_user_resumes_path,
  api_current_user_taggings_path,
  api_current_user_tags_path,
  api_current_user_tracked_reports_path,
  api_favorites_path,
  api_graph_data_posted_in_the_past_path,
  api_jobs_application_count_path,
  api_jobs_search_path,
  api_keywords_path,
  api_news_article_path,
  api_news_articles_path,
  api_news_google_docs_path,
  api_news_search_path,
  api_procurements_contact_partner_path,
  api_request_cv_recipients_path,
  api_request_cv_recipients_delete_path,
  api_search_path,
  api_system_health_path,
  api_views_path,
  apply_externally_job_path,
  apply_job_application_path,
  billing_account_path,
  bulk_confirm_admin_development_data_raw_funding_infos_path,
  campaign_path,
  campaigns_path,
  career_account_path,
  careers_organization_path,
  change_password_path,
  changes_organization_path,
  check_email_path,
  claim_admin_development_data_contract_path,
  claim_admin_development_data_funding_info_path,
  claim_admin_development_data_grant_path,
  claim_admin_development_data_job_path,
  claim_admin_development_data_open_opportunity_path,
  claim_admin_development_data_pipeline_path,
  claim_admin_development_data_tender_path,
  claim_admin_procurement_shortlist_path,
  comment_save_path,
  confirm_data_profile_index_path,
  contacts_organization_path,
  contracts_projects_path,
  countries_path,
  country_path,
  delete_job_path,
  delete_message_template_messages_path,
  devpros_2030_path,
  edit_admin_campaign_path,
  edit_admin_development_data_contract_path,
  edit_admin_development_data_grant_path,
  edit_admin_development_data_open_opportunity_path,
  edit_admin_development_data_organization_path,
  edit_admin_development_data_organization_company_link_path,
  edit_admin_development_data_pipeline_path,
  edit_admin_development_data_raw_funding_info_path,
  edit_admin_development_data_tender_path,
  edit_admin_job_path,
  edit_admin_landing_page_path,
  edit_admin_newsletter_path,
  edit_admin_payment_page_path,
  edit_admin_payment_page_item_path,
  edit_admin_procurement_shortlist_path,
  edit_admin_story_type_path,
  edit_campaign_path,
  edit_job_path,
  edit_profile_index_path,
  edit_projects_path,
  edit_projects_tgo_path,
  faith_development_path,
  feature_job_path,
  feed_jobs_path,
  feed_projects_path,
  focus_areas_path,
  focus_future_of_work_path,
  follow_campaign_path,
  funding_path,
  funding_dashboard_path,
  funding_feed_path,
  funding_overview_path,
  funding_search_path,
  funding_trends_path,
  gender_data_path,
  grant_default_projects_path,
  grant_projects_path,
  home_page_path,
  improving_nutrition_path,
  job_path,
  job_application_path,
  job_applications_path,
  job_posting_options_path,
  jobs_path,
  login_path,
  logout_path,
  membership_path,
  membership_professional_path,
  membership_professional_annual_path,
  membership_professional_membership_discount_path,
  merge_admin_development_data_organizations_path,
  messages_path,
  my_applications_jobs_path,
  my_devex_path,
  my_devex_preferences_path,
  my_jobs_path,
  new_admin_campaign_path,
  new_admin_development_data_contract_path,
  new_admin_development_data_grant_path,
  new_admin_development_data_open_opportunity_path,
  new_admin_development_data_organization_path,
  new_admin_development_data_organization_company_link_path,
  new_admin_development_data_pipeline_path,
  new_admin_development_data_raw_funding_info_path,
  new_admin_development_data_tender_path,
  new_admin_job_path,
  new_admin_landing_page_path,
  new_admin_news_lab_partner_path,
  new_admin_newsletter_path,
  new_admin_payment_page_path,
  new_admin_payment_page_item_path,
  new_admin_procurement_shortlist_path,
  new_admin_story_type_path,
  new_campaign_path,
  new_job_path,
  new_job_application_path,
  new_message_path,
  new_organization_path,
  new_projects_path,
  new_projects_tgo_path,
  news_apple_news_feed_path,
  news_article_path,
  news_author_path,
  news_authors_path,
  news_cmt_trending_path,
  news_feed_path,
  news_from_news_search_path,
  news_home_path,
  news_search_path,
  news_trending_create_path,
  news_trending_delete_path,
  news_trending_update_path,
  newsletter_signup_path,
  newsletters_account_path,
  note_path,
  notes_path,
  oauth_callback_path,
  oauth_failure_path,
  old_advanced_search_projects_path,
  old_all_projects_path,
  old_autocomplete_projects_path,
  old_dashboard_projects_path,
  old_grant_default_projects_path,
  old_grant_projects_path,
  old_open_opportunity_default_projects_path,
  old_open_opportunity_projects_path,
  old_pipeline_default_projects_path,
  old_pipeline_projects_path,
  old_pipelines_index_projects_path,
  old_pipelines_search_projects_path,
  old_premium_grant_projects_path,
  old_premium_open_opportunity_projects_path,
  old_premium_pipeline_projects_path,
  old_premium_tender_projects_path,
  old_projects_path,
  old_tender_default_projects_path,
  old_tender_projects_path,
  old_tgo_index_projects_path,
  old_tgo_search_projects_path,
  open_opportunity_default_projects_path,
  open_opportunity_projects_path,
  organization_path,
  organizations_path,
  payment_job_path,
  people_path,
  person_path,
  pipeline_default_projects_path,
  pipeline_projects_path,
  pipelines_index_projects_path,
  pipelines_search_projects_path,
  premium_grant_projects_path,
  premium_open_opportunity_projects_path,
  premium_pipeline_projects_path,
  premium_tender_projects_path,
  preview_job_path,
  preview_organization_path,
  pro_path,
  pro_subscriber_path,
  profile_index_path,
  projects_path,
  projects_organization_path,
  projects_tgo_path,
  projects_tgo_index_path,
  rails_info_path,
  rails_info_properties_path,
  rails_info_routes_path,
  recommended_candidates_job_path,
  recruiter_dashboard_path,
  recruiter_posted_jobs_path,
  recruiter_search_people_path,
  recruiting_insight_path,
  redirect_index_path,
  registration_path,
  repost_job_path,
  reset_password_path,
  search_admin_development_data_jobs_path,
  search_advanced_projects_path,
  search_all_projects_path,
  search_autocomplete_projects_path,
  search_jobs_path,
  search_organizations_path,
  search_people_path,
  search_projects_tgo_index_path,
  secure_organization_path,
  sponsored_news_article_path,
  staff_organization_path,
  state_change_admin_development_data_organizations_path,
  submit_payment_path,
  tender_default_projects_path,
  tender_projects_path,
  tgo_index_projects_path,
  tgo_search_projects_path,
  topic_landing_path,
  ui_expo_path,
  ui_expo_index_path,
  unfollow_campaign_path,
  updates_path,
  upgrade_page_path,
  upload_admin_development_data_contracts_path,
  upload_admin_development_data_funding_infos_path,
  upload_cv_profile_index_path,
  us_aid_path,
  users_organization_path,
  verify_data_profile_index_path,
  verify_email_address_account_path,
  vision_path,
  zendesk_path,
} from './js_routes_generated_file_esm_module';

export default {
  account_path,
  account_users_path,
  activate_profile_index_path,
  add_to_favorites_job_path,
  admin_campaign_path,
  admin_campaigns_path,
  admin_companies_path,
  admin_country_page_path,
  admin_country_pages_path,
  admin_dashboard_index_path,
  admin_development_data_path,
  admin_development_data_automation_dashboard_path,
  admin_development_data_contract_path,
  admin_development_data_contracts_path,
  admin_development_data_donors_path,
  admin_development_data_grant_path,
  admin_development_data_grants_path,
  admin_development_data_open_opportunities_path,
  admin_development_data_open_opportunity_path,
  admin_development_data_organization_path,
  admin_development_data_organization_company_link_path,
  admin_development_data_organization_company_links_path,
  admin_development_data_organizations_path,
  admin_development_data_pipeline_path,
  admin_development_data_pipelines_path,
  admin_development_data_raw_funding_info_path,
  admin_development_data_raw_funding_infos_path,
  admin_development_data_scrape_run_path,
  admin_development_data_scrape_runs_path,
  admin_development_data_search_path,
  admin_development_data_tender_path,
  admin_development_data_tenders_path,
  admin_funding_path,
  admin_job_path,
  admin_jobs_path,
  admin_landing_page_path,
  admin_landing_pages_path,
  admin_news_lab_article_path,
  admin_news_lab_article_assign_google_doc_path,
  admin_news_lab_articles_path,
  admin_news_lab_content_path,
  admin_news_lab_events_path,
  admin_news_lab_google_document_path,
  admin_news_lab_partners_path,
  admin_news_lab_root_path,
  admin_newsletter_path,
  admin_newsletters_path,
  admin_payment_page_path,
  admin_payment_page_item_path,
  admin_payment_page_items_path,
  admin_payment_pages_path,
  admin_permissions_path,
  admin_procurement_shortlist_path,
  admin_procurement_shortlists_path,
  admin_root_path,
  admin_story_type_path,
  admin_story_types_path,
  admin_user_path,
  admin_user_switch_path,
  admin_users_path,
  api_path,
  api_activities_path,
  api_analytics_job_applications_path,
  api_autocomplete_path,
  api_autocomplete_jobs_employer_companies_path,
  api_autocomplete_locations_path,
  api_autocomplete_places_path,
  api_autocomplete_projects_by_reference_number_path,
  api_bookmarked_search_path,
  api_consultant_request_cv_path,
  api_consultants_path,
  api_consultants_search_path,
  api_content_events_path,
  api_current_user_path,
  api_current_user_addresses_path,
  api_current_user_associations_path,
  api_current_user_credits_path,
  api_current_user_documents_path,
  api_current_user_education_path,
  api_current_user_employments_path,
  api_current_user_links_path,
  api_current_user_messengers_path,
  api_current_user_messengers_bulk_path,
  api_current_user_newsletters_path,
  api_current_user_notes_path,
  api_current_user_photos_path,
  api_current_user_profile_views_path,
  api_current_user_references_path,
  api_current_user_resumes_path,
  api_current_user_taggings_path,
  api_current_user_tags_path,
  api_current_user_tracked_reports_path,
  api_favorites_path,
  api_graph_data_posted_in_the_past_path,
  api_jobs_application_count_path,
  api_jobs_search_path,
  api_keywords_path,
  api_news_article_path,
  api_news_articles_path,
  api_news_google_docs_path,
  api_news_search_path,
  api_procurements_contact_partner_path,
  api_request_cv_recipients_path,
  api_request_cv_recipients_delete_path,
  api_search_path,
  api_system_health_path,
  api_views_path,
  apply_externally_job_path,
  apply_job_application_path,
  billing_account_path,
  bulk_confirm_admin_development_data_raw_funding_infos_path,
  campaign_path,
  campaigns_path,
  career_account_path,
  careers_organization_path,
  change_password_path,
  changes_organization_path,
  check_email_path,
  claim_admin_development_data_contract_path,
  claim_admin_development_data_funding_info_path,
  claim_admin_development_data_grant_path,
  claim_admin_development_data_job_path,
  claim_admin_development_data_open_opportunity_path,
  claim_admin_development_data_pipeline_path,
  claim_admin_development_data_tender_path,
  claim_admin_procurement_shortlist_path,
  comment_save_path,
  confirm_data_profile_index_path,
  contacts_organization_path,
  contracts_projects_path,
  countries_path,
  country_path,
  delete_job_path,
  delete_message_template_messages_path,
  devpros_2030_path,
  edit_admin_campaign_path,
  edit_admin_development_data_contract_path,
  edit_admin_development_data_grant_path,
  edit_admin_development_data_open_opportunity_path,
  edit_admin_development_data_organization_path,
  edit_admin_development_data_organization_company_link_path,
  edit_admin_development_data_pipeline_path,
  edit_admin_development_data_raw_funding_info_path,
  edit_admin_development_data_tender_path,
  edit_admin_job_path,
  edit_admin_landing_page_path,
  edit_admin_newsletter_path,
  edit_admin_payment_page_path,
  edit_admin_payment_page_item_path,
  edit_admin_procurement_shortlist_path,
  edit_admin_story_type_path,
  edit_campaign_path,
  edit_job_path,
  edit_profile_index_path,
  edit_projects_path,
  edit_projects_tgo_path,
  faith_development_path,
  feature_job_path,
  feed_jobs_path,
  feed_projects_path,
  focus_areas_path,
  focus_future_of_work_path,
  follow_campaign_path,
  funding_path,
  funding_dashboard_path,
  funding_feed_path,
  funding_overview_path,
  funding_search_path,
  funding_trends_path,
  gender_data_path,
  grant_default_projects_path,
  grant_projects_path,
  home_page_path,
  improving_nutrition_path,
  job_path,
  job_application_path,
  job_applications_path,
  job_posting_options_path,
  jobs_path,
  login_path,
  logout_path,
  membership_path,
  membership_professional_path,
  membership_professional_annual_path,
  membership_professional_membership_discount_path,
  merge_admin_development_data_organizations_path,
  messages_path,
  my_applications_jobs_path,
  my_devex_path,
  my_devex_preferences_path,
  my_jobs_path,
  new_admin_campaign_path,
  new_admin_development_data_contract_path,
  new_admin_development_data_grant_path,
  new_admin_development_data_open_opportunity_path,
  new_admin_development_data_organization_path,
  new_admin_development_data_organization_company_link_path,
  new_admin_development_data_pipeline_path,
  new_admin_development_data_raw_funding_info_path,
  new_admin_development_data_tender_path,
  new_admin_job_path,
  new_admin_landing_page_path,
  new_admin_news_lab_partner_path,
  new_admin_newsletter_path,
  new_admin_payment_page_path,
  new_admin_payment_page_item_path,
  new_admin_procurement_shortlist_path,
  new_admin_story_type_path,
  new_campaign_path,
  new_job_path,
  new_job_application_path,
  new_message_path,
  new_organization_path,
  new_projects_path,
  new_projects_tgo_path,
  news_apple_news_feed_path,
  news_article_path,
  news_author_path,
  news_authors_path,
  news_cmt_trending_path,
  news_feed_path,
  news_from_news_search_path,
  news_home_path,
  news_search_path,
  news_trending_create_path,
  news_trending_delete_path,
  news_trending_update_path,
  newsletter_signup_path,
  newsletters_account_path,
  note_path,
  notes_path,
  oauth_callback_path,
  oauth_failure_path,
  old_advanced_search_projects_path,
  old_all_projects_path,
  old_autocomplete_projects_path,
  old_dashboard_projects_path,
  old_grant_default_projects_path,
  old_grant_projects_path,
  old_open_opportunity_default_projects_path,
  old_open_opportunity_projects_path,
  old_pipeline_default_projects_path,
  old_pipeline_projects_path,
  old_pipelines_index_projects_path,
  old_pipelines_search_projects_path,
  old_premium_grant_projects_path,
  old_premium_open_opportunity_projects_path,
  old_premium_pipeline_projects_path,
  old_premium_tender_projects_path,
  old_projects_path,
  old_tender_default_projects_path,
  old_tender_projects_path,
  old_tgo_index_projects_path,
  old_tgo_search_projects_path,
  open_opportunity_default_projects_path,
  open_opportunity_projects_path,
  organization_path,
  organizations_path,
  payment_job_path,
  people_path,
  person_path,
  pipeline_default_projects_path,
  pipeline_projects_path,
  pipelines_index_projects_path,
  pipelines_search_projects_path,
  premium_grant_projects_path,
  premium_open_opportunity_projects_path,
  premium_pipeline_projects_path,
  premium_tender_projects_path,
  preview_job_path,
  preview_organization_path,
  pro_path,
  pro_subscriber_path,
  profile_index_path,
  projects_path,
  projects_organization_path,
  projects_tgo_path,
  projects_tgo_index_path,
  rails_info_path,
  rails_info_properties_path,
  rails_info_routes_path,
  recommended_candidates_job_path,
  recruiter_dashboard_path,
  recruiter_posted_jobs_path,
  recruiter_search_people_path,
  recruiting_insight_path,
  redirect_index_path,
  registration_path,
  repost_job_path,
  reset_password_path,
  search_admin_development_data_jobs_path,
  search_advanced_projects_path,
  search_all_projects_path,
  search_autocomplete_projects_path,
  search_jobs_path,
  search_organizations_path,
  search_people_path,
  search_projects_tgo_index_path,
  secure_organization_path,
  sponsored_news_article_path,
  staff_organization_path,
  state_change_admin_development_data_organizations_path,
  submit_payment_path,
  tender_default_projects_path,
  tender_projects_path,
  tgo_index_projects_path,
  tgo_search_projects_path,
  topic_landing_path,
  ui_expo_path,
  ui_expo_index_path,
  unfollow_campaign_path,
  updates_path,
  upgrade_page_path,
  upload_admin_development_data_contracts_path,
  upload_admin_development_data_funding_infos_path,
  upload_cv_profile_index_path,
  us_aid_path,
  users_organization_path,
  verify_data_profile_index_path,
  verify_email_address_account_path,
  vision_path,
  zendesk_path,
};
